import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import Chatbot from './Chatbot';

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return (
    <>
      <Navigation />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
};

export default Layout;
